import generateCreateDefaultState from './generateCreateDefaultState';
import createJobDefaultReducer from './createJobDefaultReducer';

export default (state = generateCreateDefaultState('PART_TIMER'), action) => {
  return createJobDefaultReducer('PART_TIMER', action, state);
};
